<div class="card">
  <div class="card-body">
    <div class="row achieve-number text-center">
      <h1 class="card-title" [countUp]="achievement.number" [options]="{ enableScrollSpy: true }">
        0
      </h1>
      <span>+</span>
    </div>
    <div class="row text-center">
      <h2 class="card-subtitle mb-2 text-body-secondary">
        {{achievement.description}}
      </h2>
    </div>
  </div>
</div>
